import "core-js/modules/es6.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'FibRadio',
  props: {
    color: {
      type: String,
      default: ''
    },
    disable: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true
    },
    val: {
      type: [Boolean, Number, String],
      default: false
    },
    value: {
      type: [Boolean, Number, String],
      default: false
    },
    leftLabel: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    theme: function theme() {
      return this.$store.getters['theme/theme'];
    },
    themeStyle: function themeStyle() {
      return {
        color: this.color || this.theme.primaryColor
      };
    }
  }
};